export default "/themes/nutristopa/assets/img/default-recipe.png";